import React from 'react';
import './Banner.css';
const Banner = () => {



    return (
      <div>
        <section className="banner-area mb-5">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="page-banner-content">
                  <h2>Hire Top Speakers for your conference</h2>
                  <h3>Here available total Speaker are 15</h3>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
};

export default Banner;